const map = {
	"./blog-01.jpg": 63373,
	"./blog-02.jpg": 94146,
	"./blog-03.jpg": 85855,
	"./blog-04.jpg": 7572,
	"./blog-05.jpg": 79377,
	"./blog-06.jpg": 63526,
	"./blog-07.jpg": 53635,
	"./blog-08.jpg": 96024,
	"./blog-09.jpg": 341,
	"./blog-10.jpg": 82255,
	"./blog-11.jpg": 9874,
	"./blog-12.jpg": 19773,
	"./blog-13.jpg": 68640,
	"./blog-14.jpg": 51475,
	"./blog-15.jpg": 65014,
	"./blog-16.jpg": 35361,
	"./blog-17.jpg": 57316,
	"./blog-18.jpg": 31735,
	"./blog-19.jpg": 67898
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75716;